var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Panel',{attrs:{"title":false,"footer":false}},[_c('MetadataPresenter',{attrs:{"metadata":_vm.metadata}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }